import { useNavigate } from "react-router-dom"; 
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";

const EmailCampaign = () => {
  const navigate = useNavigate();

  const defaultColumns: any = [
    {
      header: "Campaign",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Status",
      accessorKey: "is_draft",
      cell: ({ getValue }: any) => <p>{getValue() ? "Draft" : "Submitted"}</p>,
    },
    {
      header: "Date",
      accessorKey: "scheduled_time",
      cell: NACell,
    },
    {
      header: "From",
      accessorKey: "sender_email.email",
      cell: NACell,
    },
    {
      header: "Recipients",
      accessorKey: "recipient_list",
      cell: ({ getValue }: any) => {
        const emails = getValue()?.split(",") || [];
        const visibleCount = 2;
        const visibleEmails = emails.slice(0, visibleCount);
        const tooltipContent = emails.join(", ");

        return (
          <div className="flex gap-1 flex-wrap" title={tooltipContent}>
            {visibleEmails.map((email: string, index: number) => (
              <div key={index} className={tw`  `}>
                {email}
              </div>
            ))}
            {emails?.length > 2 ? "..." : ""}
          </div>
        );
      },
    },
    
  ];

  return (
    <DataTable
      url={APIS.EMAIL_CAMPAIGN}
      queryKey={"email-campaign"}
      columns={defaultColumns}
      addNewPagePath={"/email-sms-marketing/email-campaign/create"}
      tableName={"Email Campaign"}
      onRowClick={(row: any) => {
        const id = row?.original?.id;
        if (id) {
          navigate(`/email-sms-marketing/email-campaign/edit/${id}`);
        }
      }}
    />
  );
};

export default EmailCampaign;